// src/ProtectedRoute.jsx
import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { RoleContext } from "./RoleContext";

const ROLE_DASHBOARDS = {
  "Lab Admin": "/global-dashboard",
  "IT Admin": "/global-dashboard",
  "Customer": "/customer-dashboard",
  "Analyst": "/analyst-dashboard",
  "Field Staff": "/field-staff-dashboard",
};

const ProtectedRoute = ({ allowedRoles }) => {
  const { role, roleOptions } = useContext(RoleContext);

  // Only show loader if user is authenticated (roleOptions exists) but roles are not loaded yet
  const isAuthenticated = !!localStorage.getItem("userData");

  if (isAuthenticated && (roleOptions === null || roleOptions.length === 0)) {
    return (
      <div
        style={{ textAlign: "center", placeContent: "center", height: "100vh" }}
      >
        <div
          className="spinner-border"
          style={{ width: "10rem", height: "10rem" }}
          role="status"
        ></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
       // Not logged in, allow public routes
       return <Navigate to="/" replace />;
  }
  // Check if the user's currently active role is permitted for this route.
  // flushSync in Header.js guarantees context is up-to-date before navigation fires.
  const hasAccess = allowedRoles.includes(role);
  if (!hasAccess) {
    // Redirect to the role's own dashboard instead of /unauthorized
    const fallback = ROLE_DASHBOARDS[role] || "/";
    return <Navigate to={fallback} replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
